import { Box } from '@mui/material';

export default function HorizontalBars({ activeStep = 0, total=2 }) {
  return (
    <Box display="flex" justifyContent="center" gap={2} mb={3}>
      {[...Array(total)].map((_, index) => (
        <Box
          key={index}
          sx={{
            height: 6,
            width: '100%',
            borderRadius: 2,
          
            backgroundColor: index <= activeStep ? '#5E17EB' : '#e0e0e0',
            transition: 'background-color 0.3s ease',
          }}
        />
      ))}
    </Box>
  );
}
